import React, { useEffect, useState } from "react";
import Maincomponent from "../../Components/Maincomponent/Maincomponent";
import { Input } from "antd";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Space, Table, Tag } from "antd";
import axios from "axios";
import Apiurl from "../../Apiurl";
import Button from "react-bootstrap/Button";
import Studentoptions from "../../Options/Studentoptions";
import { Tabhelper } from "../../Helper/Tabhelper";
import Staffroleoptions from "../../Options/Staffroleoptions";
import Staffoptions from "../../Options/Staffoptions";

export default function Workupdate() {
  const [jsonList, setJsonList] = useState([]);
  const initialData = {
    name: "Work Update",
    link: "/workupdate",
    active: "no",
  };
  const apiurl = Apiurl();
  const navigate = useNavigate();
  const options = Staffoptions();
  const { user } = useParams();
  const [sid, setsid] = useState("");

  const [loader, setloader] = useState(false);
  const [sname, setsname] = useState(null);
  const [date, setdate] = useState("");
  const [amount, setamount] = useState("");
  const [billno, setbillno] = useState("");
  const [remarks, setremarks] = useState("");
  const [mode, setmode] = useState(null);
  const [svalue, setsvalue] = useState(0);
  const [Studentdata, setStudentdata] = useState([]);
  const [Studentbillingdata, setStudentbillingdata] = useState([]);
  const [staffdata, setstaffdata] = useState([]);
  const modeoptions = [
    { value: "Cash", label: "Cash" },
    { value: "Cheque", label: "Cheque" },
    { value: "Online", label: "Online" },
    { value: "UPI", label: "UPI" },
  ];



  const updateDate = () => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0]; // Convert date to YYYY-MM-DD format
    setdate(formattedDate);
  };


  async function GetStudData() {
    if (sname != null) {
      try {
        console.log(sname);
        const response = await axios.get(
          apiurl +
            `workupdate/?date_uploaded=&staff_id=${sname.value}&staff_name=`
        );
        const response2 = await axios.get(
          apiurl + `staffdetails/?Role=&Status=&Staffid=${sname.value}`
        );
        setstaffdata(response2.data);

        setStudentdata(response.data);
        setsname("");
      } catch (error) {
        console.error(error);
      }
    } else {
      alert("Enter Student ID");
    }
  }
  const handleStudentChange = (selectedOption) => {
    setsname(selectedOption);
  };

  useEffect(() => {
    updateDate();
  }, []);
  useEffect(() => {
    Tabhelper(initialData, setJsonList);
  }, []);


  //
  return (
    <Maincomponent tabname={"Work Update"}>
      <div className="component-sub">
        <div className="component-sub1">
          <div className="multistephead">
            <b>WORK UPDATE</b>
          </div>
          <br />
          <div className="componentsmaincont">
            {/* <div style={{ justifyContent: "center", textAlign: "center" }}>
            <b>  Enter Student name or Id</b>
            </div> */}
            <div style={{ width: "30%" }}>
              <Select
                style={{ width: "100%" }}
                value={sname}
                onChange={handleStudentChange}
                options={options}
                placeholder="Select a Staff"
              />
            </div>
            &nbsp;
            <div
              style={{
                width: "30%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Input type="date" />
            </div>
            <div>
              <button className="buttoncompnent1" onClick={GetStudData}>
                Go
              </button>
            </div>
          </div>
          <br />
          {Studentdata.length != 0 ? (
            <>
              <div className="Billcompmain">
                <div className="Billcompmain1" style={{ width: "80%" }}>
                  {" "}
                  {Studentdata.length != 0 ? (
                    <div>
                      <div>
                        <div>
                          <div style={{ justifyContent: "center" }}>
                            {/* <div className="multistephead">
                          <b>Student Info</b>
                        </div> */}
                            <br />
                            <div className="table-responsive">
                              <table className="table">
                                {staffdata.map((item, index) => (
                                  <>
                                    <tr key={item.index + 1}>
                                      <th>Name</th>
                                      <td>{item.Name}</td>
                                      <th>ID</th>
                                      <td>{item.Staffid}</td>
                                    </tr>
                                  </>
                                ))}
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <br />
              <div className="Billcompmain" style={{ flexWrap: "wrap" }}>
                {Studentdata.map((item, index) => (
                  <>
                    <div
                      style={{
                        width: "250px",
                        height: "200px",
                        border: "0.5px solid black",
                        margin: "2px",
                        borderRadius: "5px",
                        backgroundColor: "white",
                        padding: "5px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <i> {item.staff_name}</i>
                        <b>Date : {item.date_uploaded}</b>
                      </div>
                      <hr />
                      <div
                        className="workupdatemain"
                        style={{
                          height: "70%",
                          //   backgroundColor: "red",
                          overflowY: "auto",
                        }}
                      >
                        <pre>{item.work}</pre>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </>
          ) : null}
        </div>
      </div>
    </Maincomponent>
  );
}
